module.exports = __webpack_public_path__ + "static/media/bunu02.d30a1d2c.png";